// ** React Imports
import { useState } from 'react'

// ** Reactstrap Imports
import { TabContent, TabPane, Nav, NavItem, Row, Col } from 'reactstrap'
import { FaCirclePlus } from "react-icons/fa6";
import { ButtonText, CardButtons, LiveOrgPrice, ProdCardName } from '../../../../StyledComponents';
import card from '../../../../assets/images/UserPayment/card.svg'
import AddCreditCard from './AddCreditCard';
import AddBankAccount from './AddBankAccount';
import AddPayPal from './AddPayPal';
import AddEasypaisaJazzcash from './AddEasypaisaJazzcash';

const PaymentOptionsInfo = () => {
  // ** State
  const [active, setActive] = useState('0')

  const toggle = tab => {
    if (active !== tab) {
      setActive(tab)
    }
  }

  const handleSwitchTab = () => {
    setActive('0');
  };

  return (
    <div className='nav-vertical'>
      <Nav tabs className='nav-left' style={{ borderRadius: '0', borderRight: '1px solid #d9d9d9' }}>
        <ButtonText style={{ color: 'black', padding: '0.5rem' }}>Add Accounts/ Cards</ButtonText>
        <NavItem className={`custom-credit-cards ${active === '1' ? 'active' : ''}`} onClick={() => toggle('1')}>
          <div className='w-100'>
            <Row className='align-items-center'>
              <Col lg='4' xl='4'>
                <div style={{ backgroundColor: '#D9D9D9', padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                  <FaCirclePlus size={34} />
                </div>
              </Col>
              <Col lg='8' xl='8'><ProdCardName>Add Credit or Debit card</ProdCardName></Col>
            </Row>
          </div>
        </NavItem>
        <NavItem className={`custom-credit-cards ${active === '2' ? 'active' : ''}`} onClick={() => toggle('2')}>
          <div className='w-100'>
            <Row className='align-items-center'>
              <Col lg='4' xl='4'>
                <div style={{ backgroundColor: '#D9D9D9', padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                  <FaCirclePlus size={34} />
                </div>
              </Col>
              <Col lg='8' xl='8'><ProdCardName>Add Bank Account</ProdCardName></Col>
            </Row>
          </div>
        </NavItem>
        <NavItem className={`custom-credit-cards ${active === '3' ? 'active' : ''}`} onClick={() => toggle('3')}>
          {/* <div className='w-100'>
            <Row className='align-items-center'>
              <Col lg='4' xl='4'>
                <div style={{ backgroundColor: '#D9D9D9', padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                  <FaCirclePlus size={34} />
                </div>
              </Col>
              <Col lg='8' xl='8'><ProdCardName>Add Paypal</ProdCardName></Col>
            </Row>
          </div> */}
          <div className='w-100'>
            <Row className='align-items-center'>
              <Col lg='4' xl='4'>
                <div style={{ backgroundColor: '#D9D9D9', padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                  <FaCirclePlus size={34} />
                </div>
              </Col>
              <Col lg='8' xl='8'><ProdCardName>Add  Easypaisa/Jazzcash</ProdCardName></Col>
            </Row>
          </div>
        </NavItem>

      </Nav>

      <TabContent activeTab={active}>

        <TabPane tabId='0'>
          
                <ButtonText style={{ color: 'black', padding: '0.5rem', fontWeight: '500' }}>Default</ButtonText>
          <Row className='w-100'>
            <Col xl='4' lg='4' md='6' sm='12' xs='12'>
              <div>
                <div className='custom-card' style={{ width: '240px' }}>
                  <div className='custom-tab' style={{ width: '240px' }}>
                    <Row style={{ display: 'flex', alignItems: 'center' }}>
                      <Col lg='4' xl='4'>
                        <div style={{ padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                          <img src={card} />
                        </div>
                      </Col>
                      <Col lg='8' xl='8' >
                        <ProdCardName style={{ fontSize: '14px' }}>3566 **** **** ****</ProdCardName>
                        <ProdCardName style={{ fontSize: '14px' }}>Happy Customer</ProdCardName>
                        <ProdCardName style={{ fontSize: '14px' }}>21/2025</ProdCardName>
                      </Col>
                    </Row>
                  </div>
                  <div className='row-style w-100 justify-content-between px-2'>
                    <CardButtons>remove</CardButtons>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <ButtonText className='py-2' style={{ color: 'black' }}>
            <div>Your Added Accounts/ Cards</div>
          </ButtonText>
          <Row className='w-100'>
            <Col xl='4' lg='12' md='12' sm='12' xs='12'>
              <div className='custom-card' style={{ width: '240px' }}>
                <div className='custom-tab' style={{ width: '240px' }}>
                  <Row style={{ display: 'flex', alignItems: 'center' }}>
                    <Col lg='4' xl='4'>
                      <div style={{ padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                        <img src={card} />
                      </div>
                    </Col>
                    <Col lg='8' xl='8' >
                      <ProdCardName style={{ fontSize: '14px' }}>3566 **** **** ****</ProdCardName>
                      <ProdCardName style={{ fontSize: '14px' }}>Happy Customer</ProdCardName>
                      <ProdCardName style={{ fontSize: '14px' }}>21/2025</ProdCardName>
                    </Col>
                  </Row>
                </div>
                <div className='row-style w-100 justify-content-between px-2'>
                  <CardButtons>remove</CardButtons>
                  <CardButtons>Set as Default</CardButtons>
                </div>
              </div>
            </Col>
            <Col xl='4' lg='12' md='12' sm='12' xs='12'>
              <div className='custom-card' style={{ width: '240px' }}>
                <div className='custom-tab' style={{ width: '240px' }}>
                  <Row style={{ display: 'flex', alignItems: 'center' }}>
                    <Col lg='4' xl='4'>
                      <div style={{ padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                        <img src={card} />
                      </div>
                    </Col>
                    <Col lg='8' xl='8' >
                      <ProdCardName style={{ fontSize: '14px' }}>3566 **** **** ****</ProdCardName>
                      <ProdCardName style={{ fontSize: '14px' }}>Happy Customer</ProdCardName>
                      <ProdCardName style={{ fontSize: '14px' }}>21/2025</ProdCardName>
                    </Col>
                  </Row>
                </div>
                <div className='row-style w-100 justify-content-between px-2'>
                  <CardButtons>remove</CardButtons>
                  <CardButtons>Set as Default</CardButtons>
                </div>
              </div>
            </Col>
            <Col xl='4' lg='12' md='12' sm='12' xs='12'>
              <div className='custom-card' style={{ width: '240px' }}>
                <div className='custom-tab' style={{ width: '240px' }}>
                  <Row style={{ display: 'flex', alignItems: 'center' }}>
                    <Col lg='4' xl='4'>
                      <div style={{ padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                        <img src={card} />
                      </div>
                    </Col>
                    <Col lg='8' xl='8' >
                      <ProdCardName style={{ fontSize: '14px' }}>3566 **** **** ****</ProdCardName>
                      <ProdCardName style={{ fontSize: '14px' }}>Happy Customer</ProdCardName>
                      <ProdCardName style={{ fontSize: '14px' }}>21/2025</ProdCardName>
                    </Col>
                  </Row>
                </div>
                <div className='row-style w-100 justify-content-between px-2'>
                  <CardButtons>remove</CardButtons>
                  <CardButtons>Set as Default</CardButtons>
                </div>
              </div>
            </Col>
            <Col xl='4' lg='12' md='12' sm='12' xs='12'>
              <div className='custom-card' style={{ width: '240px' }}>
                <div className='custom-tab' style={{ width: '240px' }}>
                  <Row style={{ display: 'flex', alignItems: 'center' }}>
                    <Col lg='4' xl='4'>
                      <div style={{ padding: '0.5rem', display: 'flex', justifyContent: 'center' }}>
                        <img src={card} />
                      </div>
                    </Col>
                    <Col lg='8' xl='8' >
                      <ProdCardName style={{ fontSize: '14px' }}>3566 **** **** ****</ProdCardName>
                      <ProdCardName style={{ fontSize: '14px' }}>Happy Customer</ProdCardName>
                      <ProdCardName style={{ fontSize: '14px' }}>21/2025</ProdCardName>
                    </Col>
                  </Row>
                </div>
                <div className='row-style w-100 justify-content-between px-2'>
                  <CardButtons>remove</CardButtons>
                  <CardButtons>Set as Default</CardButtons>
                </div>
              </div>
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId='1'>
          {active === '1' && <AddCreditCard onSwitchTab={handleSwitchTab} />}
        </TabPane>
        <TabPane tabId='2'>
          {active === '2' && <AddBankAccount onSwitchTab={handleSwitchTab} />}
        </TabPane>
        {/* <TabPane tabId='3'>
          {active === '3' && <AddPayPal onSwitchTab={handleSwitchTab} />}
        </TabPane> */}
        <TabPane tabId='3'>
          {active === '3' && <AddEasypaisaJazzcash onSwitchTab={handleSwitchTab} />}
        </TabPane>
      </TabContent>
    </div>
  )
}

export default PaymentOptionsInfo;
